module.exports = __webpack_public_path__ + "static/media/13.7d4d959b.mp3";